module.exports = __webpack_public_path__ + "img/mailchimp.55c72daf.svg";